import React from "react";
import { Card } from "./Card";
import sticker1 from "../assets/sticker1.png";
import sticker2 from "../assets/sticker2.png";
import Versiculo from "./Versiculo";

export default function CardsSection() {
  const cards = [
    {
      title: "BOOT CAMP",

      desc: (
        <>
          Nuestro programa de entrenamiento misionero en formato campamento
          tiene tres etapas: entrenamiento, proyecto o viaje misionero y
          reporte. Preparamos a cada participante con herramientas espirituales,
          bíblicas, técnicas y prácticas durante 35 días. Esta experiencia ayuda
          a afrontar desafíos reales en diferentes partes del mundo, mientras
          los equipos misioneros impactan ciudades y los jóvenes fortalecen su
          fe mientras hacen la voluntad de Dios.{" "}
          <div style={{ textAlign: "center" }}>
            <Versiculo referencia="Marcos 16:15" />
          </div>
        </>
      ),

      image:
        "https://thumbs-us-east-1.myalbum.io/photo/1k0/3e5ea896-34be-4ac3-b74c-dde5f722675b.jpg",

      icon: sticker1,

      variant: "purple",

      buttonText: "CAMPAMENTO",
    },

    {
      title: "ACADEMIA MISIONERA",

      desc: (
        <>
          Formación integral para estudiantes de misiones, con una duración de
          dos años de estudio y un año práctico haciendo misiones. Nuestra
          currícula académica abarca formación en las áreas de estudio bíblico,
          ministerial y técnicas.{" "}
          <div style={{ textAlign: "center" }}>
            <Versiculo referencia="2 Timoteo 3:17" />
          </div>
        </>
      ),

      image:
        "https://thumbs-us-east-1.myalbum.io/photo/1k0/2cdbf44b-98d4-4def-b8a9-997b8088f3b5.jpg",

      icon: sticker2,

      variant: "green",

      buttonText2: "EN PROCESO",
    },
  ];

  return (
    <section className="container py-5">
      <div className="row g-4">
        <h1 className="fw display-10 miTitulo">Nuestros Programas</h1>
        {cards.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>
    </section>
  );
}
